/* tslint:disable */
/* eslint-disable */
/**
 * Chat
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 *
 * @export
 * @interface ChatsAvatar
 */
export interface ChatsAvatar {
  /**
   *
   * @type {number}
   * @memberof ChatsAvatar
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof ChatsAvatar
   */
  url?: string;
}
/**
 *
 * @export
 * @interface ChatsClub
 */
export interface ChatsClub {
  /**
   *
   * @type {number}
   * @memberof ChatsClub
   */
  owner?: number;
  /**
   *
   * @type {string}
   * @memberof ChatsClub
   */
  title?: string | null;
  /**
   *
   * @type {number}
   * @memberof ChatsClub
   */
  subscriptionPrice?: number | null;
}
/**
 *
 * @export
 * @interface ChatsDmUsers
 */
export interface ChatsDmUsers {
  /**
   *
   * @type {number}
   * @memberof ChatsDmUsers
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof ChatsDmUsers
   */
  name?: string;
  /**
   *
   * @type {boolean}
   * @memberof ChatsDmUsers
   */
  isAvatar?: boolean;
  /**
   *
   * @type {ChatsAvatar}
   * @memberof ChatsDmUsers
   */
  avatar?: ChatsAvatar | null;
}
/**
 *
 * @export
 * @interface ChatsSpace
 */
export interface ChatsSpace {
  /**
   *
   * @type {number}
   * @memberof ChatsSpace
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof ChatsSpace
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof ChatsSpace
   */
  price?: number;
  /**
   *
   * @type {object}
   * @memberof ChatsSpace
   */
  teaser?: object;
  /**
   *
   * @type {string}
   * @memberof ChatsSpace
   */
  type?: ChatsSpaceTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ChatsSpace
   */
  status?: ChatsSpaceStatusEnum;
  /**
   *
   * @type {string}
   * @memberof ChatsSpace
   */
  payment_type?: ChatsSpacePaymentTypeEnum;
  /**
   *
   * @type {object}
   * @memberof ChatsSpace
   */
  meta?: object | null;
  /**
   *
   * @type {ChatsSpaceConfig}
   * @memberof ChatsSpace
   */
  config?: ChatsSpaceConfig | null;
  /**
   *
   * @type {string}
   * @memberof ChatsSpace
   */
  userSlug?: string | null;
  /**
   *
   * @type {string}
   * @memberof ChatsSpace
   */
  slug?: string;
  /**
   *
   * @type {number}
   * @memberof ChatsSpace
   */
  chatId?: number | null;
  /**
   *
   * @type {ChatsAvatar}
   * @memberof ChatsSpace
   */
  cover?: ChatsAvatar | null;
}

export const ChatsSpaceTypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
} as const;

export type ChatsSpaceTypeEnum = typeof ChatsSpaceTypeEnum[keyof typeof ChatsSpaceTypeEnum];
export const ChatsSpaceStatusEnum = {
  Draft: 'draft',
  Published: 'published',
} as const;

export type ChatsSpaceStatusEnum = typeof ChatsSpaceStatusEnum[keyof typeof ChatsSpaceStatusEnum];
export const ChatsSpacePaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type ChatsSpacePaymentTypeEnum = typeof ChatsSpacePaymentTypeEnum[keyof typeof ChatsSpacePaymentTypeEnum];

/**
 *
 * @export
 * @interface ChatsSpaceConfig
 */
export interface ChatsSpaceConfig {
  /**
   *
   * @type {ChatsSpaceConfigChallenge}
   * @memberof ChatsSpaceConfig
   */
  challenge?: ChatsSpaceConfigChallenge | null;
}
/**
 *
 * @export
 * @interface ChatsSpaceConfigChallenge
 */
export interface ChatsSpaceConfigChallenge {
  /**
   *
   * @type {number}
   * @memberof ChatsSpaceConfigChallenge
   */
  finishTimestamp?: number | null;
}
/**
 *
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
  /**
   *
   * @type {Array<number>}
   * @memberof InlineObject
   */
  usersIds?: Array<number>;
}
/**
 *
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
  /**
   *
   * @type {Array<InlineResponse200Events1>}
   * @memberof InlineResponse200
   */
  events?: Array<InlineResponse200Events1>;
  /**
   *
   * @type {number}
   * @memberof InlineResponse200
   */
  unviewedCount?: number;
}
/**
 *
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  updatedAt?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2001
   */
  type?: InlineResponse2001TypeEnum;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  gsChannelId?: number | null;
  /**
   *
   * @type {Array<ChatsDmUsers>}
   * @memberof InlineResponse2001
   */
  dmUsers?: Array<ChatsDmUsers> | null;
  /**
   *
   * @type {ChatsClub}
   * @memberof InlineResponse2001
   */
  club?: ChatsClub | null;
  /**
   *
   * @type {ChatsSpace}
   * @memberof InlineResponse2001
   */
  space?: ChatsSpace | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2001
   */
  name?: string;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2001
   */
  isAvatar?: boolean;
  /**
   *
   * @type {ChatsAvatar}
   * @memberof InlineResponse2001
   */
  avatar?: ChatsAvatar | null;
}

export const InlineResponse2001TypeEnum = {
  Space: 'space',
  Club: 'club',
  Dm: 'dm',
  Platform: 'platform',
} as const;

export type InlineResponse2001TypeEnum = typeof InlineResponse2001TypeEnum[keyof typeof InlineResponse2001TypeEnum];

/**
 *
 * @export
 * @interface InlineResponse2002
 */
export interface InlineResponse2002 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002
   */
  name?: string;
  /**
   *
   * @type {ChatsAvatar}
   * @memberof InlineResponse2002
   */
  avatar?: ChatsAvatar | null;
}
/**
 *
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse2003
   */
  accessToken?: string;
}
/**
 *
 * @export
 * @interface InlineResponse2004
 */
export interface InlineResponse2004 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  updatedAt?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2004
   */
  type?: InlineResponse2004TypeEnum;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  gsChannelId?: number | null;
  /**
   *
   * @type {Array<InlineResponse2002>}
   * @memberof InlineResponse2004
   */
  dmUsers?: Array<InlineResponse2002> | null;
}

export const InlineResponse2004TypeEnum = {
  Space: 'space',
  Club: 'club',
  Dm: 'dm',
  Platform: 'platform',
} as const;

export type InlineResponse2004TypeEnum = typeof InlineResponse2004TypeEnum[keyof typeof InlineResponse2004TypeEnum];

/**
 *
 * @export
 * @interface InlineResponse200Events
 */
export interface InlineResponse200Events {
  /**
   *
   * @type {number}
   * @memberof InlineResponse200Events
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse200Events
   */
  createdAt?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse200Events
   */
  reactionType?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse200Events
   */
  isViewed?: boolean;
  /**
   *
   * @type {string}
   * @memberof InlineResponse200Events
   */
  type?: InlineResponse200EventsTypeEnum;
}

export const InlineResponse200EventsTypeEnum = {
  Reaction: 'reaction',
  Mention: 'mention',
  Reply: 'reply',
} as const;

export type InlineResponse200EventsTypeEnum =
  typeof InlineResponse200EventsTypeEnum[keyof typeof InlineResponse200EventsTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse200Events1
 */
export interface InlineResponse200Events1 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse200Events1
   */
  userId?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse200Events1
   */
  chatId?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse200Events1
   */
  messageId?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse200Events1
   */
  createdAt?: number;
  /**
   *
   * @type {Array<InlineResponse200Events>}
   * @memberof InlineResponse200Events1
   */
  events?: Array<InlineResponse200Events>;
}

/**
 * ChatApi - axios parameter creator
 * @export
 */
export const ChatApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} chatId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    chatChatIdMembersGet: async (chatId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'chatId' is not null or undefined
      assertParamExists('chatChatIdMembersGet', 'chatId', chatId);
      const localVarPath = `/chat/{chatId}/members`.replace(`{${'chatId'}}`, encodeURIComponent(String(chatId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ChatApi - functional programming interface
 * @export
 */
export const ChatApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ChatApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} chatId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async chatChatIdMembersGet(
      chatId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.chatChatIdMembersGet(chatId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * ChatApi - factory interface
 * @export
 */
export const ChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ChatApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} chatId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    chatChatIdMembersGet(chatId: number, options?: any): AxiosPromise<object> {
      return localVarFp.chatChatIdMembersGet(chatId, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * ChatApi - object-oriented interface
 * @export
 * @class ChatApi
 * @extends {BaseAPI}
 */
export class ChatApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} chatId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ChatApi
   */
  public chatChatIdMembersGet(chatId: number, options?: AxiosRequestConfig) {
    return ChatApiFp(this.configuration)
      .chatChatIdMembersGet(chatId, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * ChatsApi - axios parameter creator
 * @export
 */
export const ChatsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} chatId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    chatsChatIdEventsGet: async (chatId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'chatId' is not null or undefined
      assertParamExists('chatsChatIdEventsGet', 'chatId', chatId);
      const localVarPath = `/chats/{chatId}/events`.replace(`{${'chatId'}}`, encodeURIComponent(String(chatId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} chatId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    chatsChatIdEventsReadPost: async (chatId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'chatId' is not null or undefined
      assertParamExists('chatsChatIdEventsReadPost', 'chatId', chatId);
      const localVarPath = `/chats/{chatId}/events/read`.replace(`{${'chatId'}}`, encodeURIComponent(String(chatId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {boolean} [force]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    chatsGet: async (force?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/chats`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (force !== undefined) {
        localVarQueryParameter['force'] = force;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ChatsApi - functional programming interface
 * @export
 */
export const ChatsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ChatsApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} chatId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async chatsChatIdEventsGet(
      chatId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.chatsChatIdEventsGet(chatId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} chatId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async chatsChatIdEventsReadPost(
      chatId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.chatsChatIdEventsReadPost(chatId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {boolean} [force]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async chatsGet(
      force?: boolean,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2001>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.chatsGet(force, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * ChatsApi - factory interface
 * @export
 */
export const ChatsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ChatsApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} chatId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    chatsChatIdEventsGet(chatId: number, options?: any): AxiosPromise<InlineResponse200> {
      return localVarFp.chatsChatIdEventsGet(chatId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} chatId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    chatsChatIdEventsReadPost(chatId: number, options?: any): AxiosPromise<object> {
      return localVarFp.chatsChatIdEventsReadPost(chatId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {boolean} [force]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    chatsGet(force?: boolean, options?: any): AxiosPromise<Array<InlineResponse2001>> {
      return localVarFp.chatsGet(force, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * ChatsApi - object-oriented interface
 * @export
 * @class ChatsApi
 * @extends {BaseAPI}
 */
export class ChatsApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} chatId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ChatsApi
   */
  public chatsChatIdEventsGet(chatId: number, options?: AxiosRequestConfig) {
    return ChatsApiFp(this.configuration)
      .chatsChatIdEventsGet(chatId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} chatId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ChatsApi
   */
  public chatsChatIdEventsReadPost(chatId: number, options?: AxiosRequestConfig) {
    return ChatsApiFp(this.configuration)
      .chatsChatIdEventsReadPost(chatId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {boolean} [force]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ChatsApi
   */
  public chatsGet(force?: boolean, options?: AxiosRequestConfig) {
    return ChatsApiFp(this.configuration)
      .chatsGet(force, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * CreatorsApi - axios parameter creator
 * @export
 */
export const CreatorsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/creators`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CreatorsApi - functional programming interface
 * @export
 */
export const CreatorsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CreatorsApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creatorsGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2002>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.creatorsGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * CreatorsApi - factory interface
 * @export
 */
export const CreatorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = CreatorsApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsGet(options?: any): AxiosPromise<Array<InlineResponse2002>> {
      return localVarFp.creatorsGet(options).then(request => request(axios, basePath));
    },
  };
};

/**
 * CreatorsApi - object-oriented interface
 * @export
 * @class CreatorsApi
 * @extends {BaseAPI}
 */
export class CreatorsApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreatorsApi
   */
  public creatorsGet(options?: AxiosRequestConfig) {
    return CreatorsApiFp(this.configuration)
      .creatorsGet(options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * GsApi - axios parameter creator
 * @export
 */
export const GsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gsTokenGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/gs/token`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * GsApi - functional programming interface
 * @export
 */
export const GsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = GsApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gsTokenGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2003>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.gsTokenGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * GsApi - factory interface
 * @export
 */
export const GsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = GsApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gsTokenGet(options?: any): AxiosPromise<InlineResponse2003> {
      return localVarFp.gsTokenGet(options).then(request => request(axios, basePath));
    },
  };
};

/**
 * GsApi - object-oriented interface
 * @export
 * @class GsApi
 * @extends {BaseAPI}
 */
export class GsApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GsApi
   */
  public gsTokenGet(options?: AxiosRequestConfig) {
    return GsApiFp(this.configuration)
      .gsTokenGet(options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * PlatformApi - axios parameter creator
 * @export
 */
export const PlatformApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/platform`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlatformApi - functional programming interface
 * @export
 */
export const PlatformApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlatformApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformPost(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.platformPost(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * PlatformApi - factory interface
 * @export
 */
export const PlatformApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = PlatformApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformPost(options?: any): AxiosPromise<object> {
      return localVarFp.platformPost(options).then(request => request(axios, basePath));
    },
  };
};

/**
 * PlatformApi - object-oriented interface
 * @export
 * @class PlatformApi
 * @extends {BaseAPI}
 */
export class PlatformApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlatformApi
   */
  public platformPost(options?: AxiosRequestConfig) {
    return PlatformApiFp(this.configuration)
      .platformPost(options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersDmPost: async (inlineObject?: InlineObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/users/dm`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersDmPost(
      inlineObject?: InlineObject,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2004>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersDmPost(inlineObject, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = UsersApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersDmPost(inlineObject?: InlineObject, options?: any): AxiosPromise<InlineResponse2004> {
      return localVarFp.usersDmPost(inlineObject, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject} [inlineObject]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public usersDmPost(inlineObject?: InlineObject, options?: AxiosRequestConfig) {
    return UsersApiFp(this.configuration)
      .usersDmPost(inlineObject, options)
      .then(request => request(this.axios, this.basePath));
  }
}
